import { repaint } from 'utils/node';

class CartForm {
  constructor(element, { termsPopupActiveClass }) {
    this.element = element;
    this.termsPopupActiveClass = termsPopupActiveClass;
    this.initTerms = this.initTerms.bind(this);
  }

  initTerms() {
    const form = this.element.querySelector('form');
    if (!form) return;

    const termsInput = this.element.querySelector('.js-termsInput');
    const termsPopup = this.element.querySelector('.js-termsPopup');
    const termsAcceptBtn = this.element.querySelector('.js-termsAcceptBtn');
    const termsDeclineBtn = this.element.querySelector('.js-termsDeclineBtn');

    if (sessionStorage.getItem('acceptTerms')) {
      termsInput.checked = true;
    }

    const toggleAcceptTerms = () => {
      if (termsInput.checked) {
        sessionStorage.setItem('acceptTerms', 'true');
      } else {
        sessionStorage.removeItem('acceptTerms');
      }
    };

    const openPopup = () => {
      termsPopup.hidden = false;
      repaint(termsPopup);
      termsPopup.classList.add(this.termsPopupActiveClass);
    };

    const closePopup = () => {
      termsPopup.classList.remove(this.termsPopupActiveClass);
      termsPopup.addEventListener('transitionend', () => {
        if (!termsPopup.classList.contains(this.termsPopupActiveClass)) {
          termsPopup.hidden = true;
        }
      }, { once: true });
    };

    const submitForm = () => {
      form.submit();
    };

    termsInput.addEventListener('change', toggleAcceptTerms);

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!termsInput.checked) {
        openPopup();
      } else {
        submitForm();
      }
    });

    termsAcceptBtn.addEventListener('click', () => {
      termsInput.checked = true;
      closePopup();
      submitForm();
    });

    termsDeclineBtn.addEventListener('click', closePopup);
  }
}

export default CartForm;
